import { FAST_QA_MODE, DEEP_THINK_MODE } from '../../../config/constant';

type TThinkValueItem = { type?: string; value?: unknown; };

/** think.value 变化时需要重新渲染 */
const hasThinkValueChanged = (
  prevValue?: TThinkValueItem[],
  nextValue?: TThinkValueItem[],
): boolean => {
  if ((prevValue?.length ?? 0) !== (nextValue?.length ?? 0)) {
    return true;
  }
  const prevToken = prevValue?.find(i => i.type === 'current_token_total')?.value;
  const nextToken = nextValue?.find(i => i.type === 'current_token_total')?.value;
  const prevFoldMode = prevValue?.find(i => i.type === 'think_fold_mode')?.value;
  const nextFoldMode = nextValue?.find(i => i.type === 'think_fold_mode')?.value;
  return prevToken !== nextToken || prevFoldMode !== nextFoldMode;
};

/** ThinkCmp memo：true 表示 props 相等、跳过重渲染 */
export const shouldSkipThinkCmpRender = (
  prevProps: {
    mode?: string;
    value?: TThinkValueItem[];
    answer?: Array<{ type?: string; }>;
    thinkTimeSeconds?: number;
  },
  nextProps: {
    mode?: string;
    value?: TThinkValueItem[];
    answer?: Array<{ type?: string; }>;
    thinkTimeSeconds?: number;
  },
): boolean => {
  if (nextProps?.mode === FAST_QA_MODE) {
    return false;
  }
  if (nextProps?.mode === DEEP_THINK_MODE) {
    if (hasThinkValueChanged(prevProps.value, nextProps.value)) {
      return false;
    }
    const hasNonThinkInNext = nextProps.answer?.some(
      item => item.type !== 'think',
    );
    return !hasNonThinkInNext && !!nextProps.thinkTimeSeconds;
  }
  return false;
};
